<template>
    <div id="category_slider">
        <carousel v-if="isLoaded && isHaveCategory"
            :responsive="configCarousel.responsive"
            :lazyLoad="true"
            :loop="false"
            :autoplay="false"
            :nav="false"
            :dots="false">
                <div class="category-item"
                    v-for="(category, k) in categories"
                    :key="k"
                    @click="clickCategory(category, k)">
                    <div class="category-icon" :class="{'active': category.id == selectedCategory, 'icon-all': category.name_en.toUpperCase() === 'ALL'}">
                        <img class="img_fluid" :src="getImageCategory(category)"/>
                    </div>
                    <p class="category-text" :class="{'active': category.id == selectedCategory, 'icon-all': category.name_en.toUpperCase() === 'ALL'}">
                        {{locale === 1054 ? category.name_th : category.name_en}}
                    </p>
                </div>
        </carousel>
    </div>
</template>
<script>
// import Vue from 'vue';
//mixin
import AccountMixin from '@/mixin/AccountMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
import Locale from '@/helper/locale/locale.js';
//helper
import Account from '@/helper/AccountHelper.js';
//plugin
import Carousel from 'vue-owl-carousel';
//service
import BzbsCategory from "@/core/Campaign/service/BzbsCategory.js";

export default {
    name: 'CategorySlider',
    mixins: [
        AccountMixin,
        LocaleMixin
    ],
    components: {
        Carousel
    },
    props: {
        apiConfig: Object,
    },
    data: function () {
        return {
            currentTab: '',

            categories: [],
            selectedCategory: 0, //for look up
            isHaveCategory: false,
            isLoaded: false,
            

            configCarousel: {
                responsive: {
                    0: { items: 3 },
                },
            },
            locale: Locale.getLocaleCode(),
            localeShort: Locale.getLocaleShort(),
        
        };
    },mounted: function () {
        //this.busEvent.$on("switchLang", this.switchLang);
    },
    created: function () {
        this.initialCategory();
    },
    methods: {
        clickCategory: function (category) {
            let categoryFromLanding = Account.getCacheCustom('category');
            if(categoryFromLanding){
                Account.removeCacheCustom('category');
                this.selectedCategory = categoryFromLanding.id;
            }else{
                this.selectedCategory = category.id;
            }
            this.$emit('clickCategory', category);
        },
        initialCategory: function () {
            var categoryParam = this.apiConfig
                .getParams();

            var token = this.getToken();

            BzbsCategory.apiGetCategory(token, categoryParam)
                .then((categories) => {
                    for (var category of categories) {
                        this.categories.push(category);
                    }

                    this.isLoaded = true;
                    this.isHaveCategory = this.categories.length > 0
                        ? true
                        : false;

                    this.clickCategory(this.categories[0]);
                }).catch((error) => {
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    this.$emit('cateError', error);
                });
        },
        getImageCategory: function(category){
            var isActive = false;
            if(category.id == this.selectedCategory){
                isActive = true;
            }else{
                isActive = false;
            }

            if (category.image_url == undefined)
                return isActive ? `/img/icon/icon_all_active.png` : `/img/icon/icon_all_inactive.png`;
            else
                return isActive ? category.image_url_active : category.image_url_inactive;
        },
        switchLang: function() {
            this.categories = [];
            this.initialCategory();
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";

.category-item {
    
    .category-icon {
        width: 45px;
        height: 45px;
        margin: auto;
        border-radius: 50%;

        &.icon-all{
            // background-color: $white;
            // border-radius: 50%;
            // margin: auto;
            // padding: 10px;
            // border: 1px solid $a-gray-A0A0A0;

            // &.active {
            //     background-color:  $green-00987F;
            //     border: 1px solid  $green-00987F;

            // }   
        }
    }

    .category-text{
        font-size: 1.5rem;
        color: $text-gray;
        font-family: $regular;
        text-transform: uppercase;
        line-height: 1;
        margin-top: 8px;
        margin-bottom: 0;
        text-align: center;

        &.active {
            color: $green-00987F;
        }
    }
}
</style>
<style lang="scss">

#category_slider{

    ::-webkit-scrollbar {
        width: 1px;
        height: 3px;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #bfbfbf;
    }

    // .owl-carousel .owl-stage-outer {
    //     overflow: scroll;
    //     overflow-y: hidden;
    //     display: flex;
    //     justify-content: center;
    // }

}

</style>
